import { render, staticRenderFns } from "./AntrfileImageEl.vue?vue&type=template&id=49e13ee0&scoped=true&"
import script from "./AntrfileImageEl.vue?vue&type=script&lang=ts&"
export * from "./AntrfileImageEl.vue?vue&type=script&lang=ts&"
import style0 from "./AntrfileImageEl.vue?vue&type=style&index=0&id=49e13ee0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e13ee0",
  null
  
)

export default component.exports